import { render, staticRenderFns } from "./UserManageDetail.vue?vue&type=template&id=81330ce4&scoped=true&"
import script from "./UserManageDetail.vue?vue&type=script&lang=js&"
export * from "./UserManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserManageDetail.vue?vue&type=style&index=0&id=81330ce4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81330ce4",
  null
  
)

export default component.exports